/**
 * A failed API call reaches route loaders in three shapes: a session
 * failure as react-router `data('unauthorized', { status: 401 })` (see
 * transport.ts), a rejected request as a ResponseError/FetchError carrying
 * `response`, and a dropped connection as a bare TypeError with no status.
 *
 * Only a 401 proves the session is gone; a 403 that still reaches here
 * carries an application code (transport.ts converted the bare ones) and
 * is a refusal of the action. Everything else is an outage, and treating
 * it as "not signed in" pushes a returning user back through onboarding or
 * shows an empty profile as if the data were lost.
 */
export function isUnauthorizedFailure(error: unknown): boolean {
    if (!error || typeof error !== 'object') return false
    const candidate = error as {
        status?: number
        init?: { status?: number } | null
        response?: { status?: number } | null
    }
    const statuses = [
        candidate.status,
        candidate.init?.status,
        candidate.response?.status
    ]
    return statuses.some((s) => s === 401)
}
